import React, { ReactNode, useEffect } from "react";
import "./resources/scss/CampaignPanel.scss";
import CampaignPanelVideo from "./components/CampaignPanelVideo";
import CloseIcon from "./icons/CloseIcon";
import TopBanner from "./components/TopBanner";

export interface VideoConfig {
  url: string;
  disableControls?: boolean;
  initialTime?: number;
  width?: string;
  height?: string;
  muted?: boolean;
  onTimeUpdate?: (currentTime: number) => void;
  handleEventTracking?: ({
    videoCurrentTime,
    videoDuration,
    videoEnded,
  }: {
    videoCurrentTime?: number;
    videoDuration?: number;
    videoEnded?: boolean;
  }) => void;
  noplaybackrate?: boolean,
  disablePictureInPicture?: boolean,
}

interface CampaignPanelProps {
  isOpen?: boolean;
  onClose?: () => void;
  children?: ReactNode;
  width?: string;
  height?: string;
  fullScreen?: boolean;
  allowClose?: boolean;
  position?: "center" | "top" | "bottom";
  className?: string;
  styleContainer?: React.CSSProperties;
  closeDelay?: number;
  video?: VideoConfig;
  panelType?: "top-banner" | "custom";
  topBannerStyles?: {
    containerStyles?: React.CSSProperties;
    subContainerStyles?: React.CSSProperties;
  };
  siteContext?: string;
  allowSeek?: boolean;
  onVideoComplete?: (e: any) => void;
  platform?: "seeker" | "recruiter"
}

const CampaignPanel: React.FC<CampaignPanelProps> = ({
  isOpen,
  onClose=()=>{},
  children,
  width,
  height,
  fullScreen = false,
  allowClose = true,
  position = "center",
  className = "",
  styleContainer,
  closeDelay = 6000,
  video,
  panelType = "top-banner",
  topBannerStyles,
  siteContext,
  allowSeek = true,
  onVideoComplete=()=>{},
  platform
}) => {
  const [canClose, setCanClose] = React.useState(allowClose);
  const [isMiniPlay, setIsMiniPlay] = React.useState(typeof window !== "undefined" ? localStorage?.getItem("miniPlay") === "true":false);

  useEffect(() => {
    setCanClose(allowClose);
  }, [allowClose]);


  if (panelType === "top-banner" || !panelType) {
    return <TopBanner topBannerStyles={topBannerStyles || {}} siteContext={siteContext} platform={platform}/>;
  }

  if (!isOpen) return null;

  const handleClose=(e:any)=>{
    e.preventDefault();
    onClose();
    setIsMiniPlay(true);
    localStorage.setItem("miniPlay","true");
  }

  return (
    <div
      className={`rec_cp_backdrop ${fullScreen ? "" : `rec_cp_position-${position}`} ${isMiniPlay ? "nobackdrop":""}`}
    >
      {!isMiniPlay && <div className="rec_cp_blur"/>}
      <div
        className={`rec_cp_play ${fullScreen ? "rec_cp_relative" : ""} ${isMiniPlay ? "rec_cp_miniPlay":""}`}
        style={{
          width: fullScreen ? "100vw" : width,
          height: fullScreen ? "100vh" : height,
          maxWidth: fullScreen ? "100vw" : "924px",
          maxHeight: fullScreen ? "100vh" : "530px",
          right: isMiniPlay ? "24px" : `calc((100% - ${width})/2)`,
          bottom: isMiniPlay ? "24px" : `calc((100% - ${height})/2)`,
        }}
      >
        {canClose && !isMiniPlay && (
          <div className="rec_cp_closeCustom" onClick={handleClose} role="button" aria-label="Close"/>
        )}
        <div
          className={`rec_cp_container ${fullScreen ? "full-screen" : ""} ${className}`}
          style={{
            ...styleContainer,
          }}
        >
          <div className="rec_cp_inner-container">
            {video?.url ? (
              <CampaignPanelVideo
                video={video}
                allowClose={allowClose}
                onVideoEnded={(e) => {
                  setCanClose(true);
                  onVideoComplete(e);
                }}
                onCenterPlayClick={()=>setIsMiniPlay(false)}
                allowSeek={allowSeek}
                isMiniPlay={isMiniPlay}
              >
                {children}
              </CampaignPanelVideo>
            ) : (
              children
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignPanel;
